<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';

import Button from 'dashboard/components-next/button/Button.vue';
import TeleportWithDirection from 'dashboard/components-next/TeleportWithDirection.vue';
import WhatsAppCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppCampaign/WhatsAppCampaignForm.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const addCampaign = async campaignDetails => {
  try {
    await store.dispatch('campaigns/create', campaignDetails);

    useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
      type: CAMPAIGN_TYPES.ONE_OFF,
    });

    useAlert(t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.SUCCESS_MESSAGE'));
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleSubmit = campaignDetails => {
  addCampaign(campaignDetails);
};

const handleClose = () => emit('close');
</script>

<template>
  <TeleportWithDirection to="body">
    <div
      class="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6 bg-n-slate-1/60 dark:bg-n-solid-1/80 backdrop-blur-sm overflow-y-auto"
      @click.self="handleClose"
    >
      <div
        class="relative w-full max-w-2xl my-auto max-h-[90vh] overflow-y-auto bg-n-surface-1 dark:bg-n-solid-2 p-6 sm:p-8 rounded-2xl border border-n-weak shadow-2xl flex flex-col gap-6"
        @click.stop
      >
        <div
          class="flex items-center justify-between pb-3 border-b border-n-weak"
        >
          <h3 class="text-lg font-semibold text-n-slate-12">
            {{ t(`CAMPAIGN.WHATSAPP.CREATE.TITLE`) }}
          </h3>
          <Button
            icon="i-lucide-x"
            variant="ghost"
            color="slate"
            size="sm"
            class="!w-8 !h-8 !p-0"
            @click="handleClose"
          />
        </div>
        <WhatsAppCampaignForm @submit="handleSubmit" @cancel="handleClose" />
      </div>
    </div>
  </TeleportWithDirection>
</template>
